export const TOKEN_KEY = 'token';
export const LEGACY_TOKEN_KEY = 'dealider_token';
export const ORIGINAL_TOKEN_KEY = 'original_token';

export const getStoredToken = () => {
  const token = localStorage.getItem(TOKEN_KEY) || localStorage.getItem(LEGACY_TOKEN_KEY);
  if (token && !localStorage.getItem(TOKEN_KEY)) {
    localStorage.setItem(TOKEN_KEY, token);
  }
  if (token && !localStorage.getItem(LEGACY_TOKEN_KEY)) {
    localStorage.setItem(LEGACY_TOKEN_KEY, token);
  }
  return token;
};

export const storeToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(LEGACY_TOKEN_KEY, token);
};

export const clearStoredTokens = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(LEGACY_TOKEN_KEY);
};